<template>
  <div
    :class="['recommendBox', isFullScreen ? 'isFullScreen' : '']"
    @click.self="$emit('closeRecommend')"
  >
    <div class="content">
      <div v-show="!isFullScreen" class="close" @click="$emit('closeRecommend')">
        <img src="@/assets/img/public/popup_close.png" alt="" />
      </div>
      <template v-if="courseVOList.length || couponVOList.length">
        <div class="tabList">
          <p
            v-for="(item, index) in tabList"
            :key="index"
            v-show="item.show"
            :class="current === index ? 'active' : ''"
            @click="current = index"
          >
            {{ item.name }}
          </p>
        </div>
        <div class="listBox">
          <RecommendCourse :type="'new'" :courseVOList="courseVOList" v-show="current === 0" />
          <RecommendCoupon
            :couponVOList="couponVOList"
            v-show="current === 1"
            @resetCoupon="getLiveRecommends"
          />
        </div>
      </template>
      <div v-else class="noRecommend">
        <img src="../../../assets/img/live/norecommend.png" alt="" />
      </div>
    </div>
  </div>
</template>
<script>
import RecommendCourse from './recommendCourse.vue';
import RecommendCoupon from './recommendCoupon.vue';
import { liveRecommends } from '@/api/live/index';
export default {
  data() {
    return {
      tabList: [
        { name: '精选课程', show: true },
        { name: '优惠券', show: true },
      ],
      current: 0,
      couponVOList: [],
      courseVOList: [],
    };
  },
  props: ['isFullScreen', 'recommendPopup', 'idx'],
  components: {
    RecommendCourse,
    RecommendCoupon,
  },
  watch: {
    recommendPopup(val) {
      if (val) {
        // idx 0 券 1 课程 -1 都展示
        if (this.idx == -1) {
          this.tabList.forEach((ele, i) => {
            Object.assign(ele, { show: true });
          });
          this.current = 0;
        } else {
          this.tabList.forEach((ele, i) => {
            Object.assign(ele, { show: false });
            if (this.idx === i) {
              Object.assign(ele, { show: true });
            }
          });
          this.current = this.idx;
        }

        this.resest();
        this.getLiveRecommends();
      }
    },
    current() {
      this.resest();
    },
  },
  methods: {
    async getLiveRecommends() {
      let liveId = this.$route.query.liveId || this.$route.params.resourceId;
      const { data } = await liveRecommends({ liveId });
      this.couponVOList = data.couponVOList ?? [];
      this.courseVOList = data.courseVOList ?? [];
      this.$emit('sendCouponList', this.couponVOList);
      if (this.courseVOList.length === 0) {
        this.tabList[0].show = false;
        this.current = 1;
      }
      if (this.couponVOList.length === 0) {
        this.tabList[1].show = false;
        this.current = 0;
      }
    },
    resest() {
      const listBox = document.getElementsByClassName('listBox')[0];
      listBox.scrollTop = 0;
    },
  },
  mounted() {
    this.getLiveRecommends();
  },
};
</script>
<style lang="scss" scoped>
.recommendBox {
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 120;
  width: 100%;
  height: 100vh;
  background: rgba(0, 0, 0, 0.3);
  .content {
    position: absolute;
    bottom: 0;
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 70%;
    background: #f7f8fc;
    border-radius: 36px 36px 0 0;
    .close {
      position: absolute;
      top: 20px;
      right: 30px;
      img {
        width: 32px;
        height: 32px;
      }
    }
    .tabList {
      display: flex;
      padding: 0 36px;
      p {
        position: relative;
        display: flex;
        align-items: center;
        justify-content: center;
        width: 200px;
        height: 80px;
        color: #333;
        font-weight: 400;
        font-size: 29px;
      }
      .active {
        font-weight: 500;
      }
      .active::after {
        position: absolute;
        bottom: 0;
        left: 50%;
        width: 36px;
        height: 5px;
        background: #ff6c02;
        transform: translateX(-50%);
        content: '';
      }
    }
    .listBox {
      position: relative;
      flex-grow: 1;
      width: 100%;
      overflow-y: scroll;
    }
    .noRecommend {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      height: 100%;
      img {
        width: 400px;
        height: 208px;
      }
    }
  }
}
.isFullScreen {
  height: 100vw;
  .content {
    top: 0;
    right: 0;
    width: 50%;
    height: 100%;
    border-radius: 0;
    .active::after {
      display: none !important;
    }
  }
}
</style>
